import { render, staticRenderFns } from "./ManageTaxonomyTree.vue?vue&type=template&id=8290ba6e&scoped=true&lang=pug"
import script from "./ManageTaxonomyTree.vue?vue&type=script&lang=js"
export * from "./ManageTaxonomyTree.vue?vue&type=script&lang=js"
import style0 from "./ManageTaxonomyTree.vue?vue&type=style&index=0&id=8290ba6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8290ba6e",
  null
  
)

export default component.exports